/**
 * Created by d-14 on 22/8/17.
 */
import { InjectionToken} from '@angular/core';

export let APP_CONFIG = new InjectionToken('app.config');

export class IAppConfig {
    apiEndpoint: string;
    domainname: string;
googleLoginProvider: string;
    facebookLoginProvider: string;
}

export const AppConfig: IAppConfig = {
    apiEndpoint: 'https://onefuture-backend.c2nav.com/api/',
    /* apiEndpoint: 'http://api.onefuture.com/api/',*/
    domainname: '.c2nav.com',
    googleLoginProvider: '133198752932-3qehpembb32c1ulfd5jdb8vk9uk8gmkd.apps.googleusercontent.com',
    facebookLoginProvider: '212796945949974'
};



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/app.config.ts